<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Opsiyonlar"
    }
</script>

<style scoped>

</style>